module.exports = __webpack_public_path__ + "img/znapshot.5ed4f3c7.png";